import { render, staticRenderFns } from "./answerShortQuestions.vue?vue&type=template&id=bf376820&scoped=true&"
import script from "./answerShortQuestions.vue?vue&type=script&lang=js&"
export * from "./answerShortQuestions.vue?vue&type=script&lang=js&"
import style0 from "./answerShortQuestions.vue?vue&type=style&index=0&id=bf376820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf376820",
  null
  
)

export default component.exports